
<!-- PIPELINE LICENSE RENEWAL(CREATE STAGE)=================================PIPELINE LICENSE RENEWAL (CREATE STAGE) =======================================PIPELINE LICENSE RENEWAL(CREATE STAGE)======================= -->

<!-- TASK SUMMARY CARD============================= TASK SUMMARY CARD===================TASK SUMMARY CARD-->

<div [formGroup]="activityForm">

  <div class="top">
    <h2 class="title">Create Stage</h2>
    <button class="default_secondary-btn" (click)="newStage(activityForm.value)">Create New Stage</button>
    <button class="default_secondary-btn" (click)="backToTemplate()">Back To Template</button>

  </div>

  <div class="top_form">
    <div class="form">
      <div class="input">
        <label for="">Stage Name</label>
        <input
          type="text"
          class="default_input reference-form"
          formControlName="PipelineLicenseStageName"
        />
      </div>
      <div class="input">
        <label for="">Duration in (days)</label>
        <input
          type="number"
          class="default_input reference-form"
          formControlName="EstimatedDuration"
        />
      </div>

      <button [disabled]="f['PipelineLicenseStageName'].errors || f['EstimatedDuration'].errors "
        class="default_secondary-btn"
        (click)="addActivity(activityForm.value)"
      >
        Add Task
      </button>
    </div>
  </div>

  <div class="new_task-modal" formGroupName="Activity" *ngIf="activityForm.value.Activity" >
    <div class="centralize" *ngIf="newActivity">
      <div class="modal_card">
        <div class="modal_input">
          <div class="top">
            <h2 class="title">Create Task</h2>

            <mat-menu #action="matMenu">
              <button
                mat-menu-item
                (click)="addActivityAction(identityuser.Id)"
                *ngFor="let identityuser of identityusers"
              >
                <!-- <mat-icon>dialpad</mat-icon> -->
                <span>{{ identityuser.StaffName}}</span>
              </button>
            </mat-menu>

          </div>
          <div class="form">
            <div class="input">
              <label for="">Task Name</label>
              <input
                type="text"
                class="default_input reference-form"
                formControlName="Name"
              />
            </div>
            <div class="input">
              <label for="">Duration in (days)</label>
              <input
                type="number"
                class="default_input reference-form"
                (keyup)="checkActivity(activityForm.value)" 
                formControlName="EstimatedDuration"
              />
            </div>
            <div class="action_entry" formArrayName="Actionpersons">
              <span class="action_person-selected">{{totalactions(activityForm.controls.Activity.value.id)}} action person(s)</span>
              <p >

                  <span  *ngFor="
                  let user of activityForm.controls.Activity.get(
                    'Actionpersons'
                  )['controls'];
                  index as i
                "
                [formGroupName]="i">{{getIdentityUser(user.value.StaffId)}}<em class="ti-close"></em> </span>
              </p>
            </div>

            <div class="submit">
              <button class="default_primary-button" [matMenuTriggerFor]="action" 
              [disabled]="activityForm.invalid">
                Add Action Person

              </button>
            </div>
          </div>
        </div>

        <div class="other_info">
          <div class="top_btn">

            <div class="action"></div>
            <button [matMenuTriggerFor]="menu" >
              <em class="ti-plus"></em> Add Stakeholder
            </button>
          </div>

          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              (click)="addMatrix(stakeholder)"
              *ngFor="let stakeholder of stakeholders"
            >
              <!-- <mat-icon>dialpad</mat-icon> -->
              <span>{{ stakeholder.PipelineLicenseStakeholderName }}</span>
            </button>
          </mat-menu>

          <div class="stakeholder_entry" formArrayName="Stakeholdermatrix">
            <div
              *ngFor="
                let matrix of activityForm.controls.Activity.get(
                  'Stakeholdermatrix'
                )['controls'];
                index as i
              "
              [formGroupName]="i"
            >
              <div class="stakeholder_entry-card">
                <mat-menu #menu2="matMenu">
                  <button
                    mat-menu-item
                    (click)="addRaci(raci.id, matrix.value, i)"
                    *ngFor="let raci of racies"
                  >
                    <!-- <mat-icon>dialpad</mat-icon> -->
                    <span>{{ raci.HierarchyName }}</span>
                  </button>
                </mat-menu>
                <div class="name_date">
                  <h2 class="stakeholder">
                    {{ getStakeholderName(matrix.value.PLStakeholderId) }}
                  </h2>
                  <input
                    class="default_secondary-btn"
                    formControlName="EstimatedDuration"
                    
                    (keyup)="checkMatrixDuration(matrix.value.EstimatedDuration, activityForm.controls.Activity.value, i)" 
                    type="number"
                    placeholder="Duration in (days)"
                  /><em class="ti-time"></em> 
                </div>

                <div class="raci_sect" formArrayName="Racies">
                  <div
                    class="raci_select"
                    *ngFor="
                      let raci of matrix.get('Racies')['controls'];
                      index as j
                    "
                    [formGroupName]="j"
                  >
                    <span class="raci float-right"
                      >{{ getRaciName(raci.value)
                      }}<i
                        class="ti-close"
                        (click)="deleteRaci(raci.value, i, j)"
                      ></i
                    ></span>
                  </div>
                  <button class="add_raci" [matMenuTriggerFor]="menu2">
                    <em class="ti-plus"></em> Raci
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- TASK SUMMARY CARD============================= TASK SUMMARY CARD===================TASK SUMMARY CARD-->

  <div class="centralize">
    <div class="task_entries">
      <div
        class="task_card"
        *ngFor="let mydata of savedactivities"
        (click)="setActivity(mydata)"
      >
        <div class="top">
          <p class="duration" *ngIf="getSavedStage(mydata.PLStageId)" >{{ getSavedStage(mydata.PLStageId).EstimatedDuration }} days</p>
          <em class="ti-more-alt"></em> 
        </div>

        <div class="task_name"  >
          <h2 class="name" *ngIf="getSavedStage(mydata.PLStageId)">{{ getSavedStage(mydata.PLStageId).PipelineLicenseStageName }}</h2>
        </div>
        <h2 class="matrix_header">{{mydata.Name}}</h2>
        <div
          class="full_summary"
          *ngFor="let smatrix of mydata.Stakeholdermatrix"
        >
          <div class="stakeholder_part">
            <span class="stakeholder">{{
              getStakeholderName(smatrix.PLStakeholderId)
            }}</span>
          </div>

          <div class="raci_part" *ngFor="let raci of smatrix.Racies">
            <span class="stakeholder">{{ getRaciName(raci) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="btn_holder">
    <button
    [disabled]="activityForm.invalid"
      class="default_primary-button"
      (click)="onSubmitActivity(activityForm.value)"
    >
      Submit
    </button>
  </div>

  <!-- <pre>{{activityForm.value | json}}</pre> -->
</div>
